<template>
  <div>
    <div
      class="text-primary xl:text-center font-DaysOne xl:text-[32px] md:text-[28px] text-[22px]"
    >
      {{ $t(content.title) }}
    </div>
    <div class="xl:text-[18px] text-[16px] text-[#1F1F1F] md:mt-4 mt-2">
      {{ $t(content.subtitle) }}
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "partners",
  },
});

const text = {
  partners: {
    title: "partner-form.partners.title",
    subtitle: "partner-form.partners.subtitle",
  },
  investors: {
    title: "partner-form.investors.title",
    subtitle: "partner-form.investors.subtitle",
  },
};

const content = computed(() => text[props.type]);
</script>
